<p>Дали има друг оператор </p>


  <mat-dialog-actions class="d-flex justify-content-end gap-3 mt-3 px-3">
    <button mat-button [mat-dialog-close]="'no'">Не</button>
    <button mat-flat-button 
    color="primary" 
    type="submit"
    [mat-dialog-close]="'yes'">Да</button>
  </mat-dialog-actions>
